import React from 'react';
import { FiX, FiUsers, FiMail, FiArrowRight } from 'react-icons/fi';

/**
 * NoOrganizationPopup - Shows when individual users try to access organization features
 */
const NoOrganizationPopup = ({ isOpen, onClose, trigger = 'access_attempt' }) => {
  if (!isOpen) return null;

  const handleContactSupport = () => {
    // You can customize this based on your support system
    window.open('mailto:support@Tasklina.com?subject=Organization Access Request', '_blank');
  };

  const handleJoinOrganization = () => {
    // You can redirect to a join organization flow
    console.log('Redirect to join organization flow');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full mx-4 transform transition-all">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
              <FiUsers className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Organization Access Required
              </h3>
              <p className="text-sm text-gray-500">Individual Account Detected</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
          >
            <FiX className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiUsers className="w-8 h-8 text-orange-500" />
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">
              You Don't Belong to Any Organization
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              The feature you're trying to access is only available to organization members. 
              You currently have an individual account.
            </p>
          </div>

          {/* Current Status */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h5 className="font-medium text-gray-900 mb-2">Your Current Account Type:</h5>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-sm text-gray-700">Individual Account</span>
            </div>
            <div className="flex items-center space-x-2 mt-1">
              <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
              <span className="text-sm text-gray-500">Organization Member</span>
            </div>
          </div>

          {/* Action Options */}
          <div className="space-y-3">
            <button
              onClick={handleJoinOrganization}
              className="w-full flex items-center justify-center space-x-2 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FiUsers className="w-4 h-4" />
              <span>Join an Organization</span>
              <FiArrowRight className="w-4 h-4" />
            </button>

            <button
              onClick={handleContactSupport}
              className="w-full flex items-center justify-center space-x-2 bg-gray-100 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <FiMail className="w-4 h-4" />
              <span>Contact Support</span>
            </button>

            <button
              onClick={onClose}
              className="w-full text-center text-gray-500 py-2 hover:text-gray-700 transition-colors text-sm"
            >
              Continue with Individual Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoOrganizationPopup;